import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Drawer, Button, Space, notification } from "antd";
import Pagination from "@mui/material/Pagination";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter, faCloudDownload, faEye, faFileArchive, faCheck } from '@fortawesome/free-solid-svg-icons';

import TobNavBar from "../../DashBaord/Top_navbar";

import { Link, useNavigate } from "react-router-dom";

import SkeltonList from "../../../components/SkeltonEffect/list";
import {
  list,
} from "../../../controllers/V1/userRequestController";
import { getPage } from "../../../controllers/common";

import ExportPopup from './Export';
import { usePermissions } from "../../../controllers/PermissionContext";
import UserSelectWithSearch from "../../../components/UserSelectWithSearch";
import moment from "moment";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";
import RequestDetailsPDF from "./RequestDetailsPDF";
import { API_BASE_URL } from "../../../config/constants";
import { getBas264Image } from '../../../controllers/V1/generalDataController';

const isStageCompleted = (value) =>
  String(value ?? "").toLowerCase() === "approved";

function UserRequestStatusDots({ item }) {
  const overall = item?.status;
  if (String(overall ?? "").toLowerCase() === "rejected") {
    return <span>{item?.status}</span>;
  }
  const isApproved = String(overall ?? "").toLowerCase() === "approved" || String(overall ?? "").toLowerCase() === "completed";
  const dots = isApproved
    ? ["green", "green"]
    : [
        isStageCompleted(item?.bdm_status) ? "green" : "red",
        isStageCompleted(item?.deployment_status) ? "green" : "red",
      ];
  return (
    <span
      className="user-request-status-dots"
      style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
      title={`BDM: ${item?.bdm_status ?? "-"} · Deployment: ${item?.deployment_status ?? "-"}`}
    >
      {dots.map((c, i) => (
        <span
          key={i}
          style={{
            width: 10,
            height: 10,
            borderRadius: "50%",
            backgroundColor: c === "green" ? "#28a745" : "#dc3545",
            flexShrink: 0,
          }}
        />
      ))}
      {isApproved && (
        <FontAwesomeIcon
          icon={faCheck}
          style={{ color: "#28a745", fontSize: 18 }}
          aria-hidden
        />
      )}
    </span>
  );
}

function VendorList(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

VendorList.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs() {
  const PERMISSION = usePermissions("userRequest");
  const [isFilterShow, setFilterShow] = useState(false);
  const handleFilterDrawer = () => setFilterShow(!isFilterShow);

  const [isExportShow, setExportShow] = useState(false);
  const handleExportDrawer = () => setExportShow(!isExportShow);

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  /************************************************************************************* */
  const [isLoading, setIsLoading] =useState(true);
  const navigate = useNavigate();
  const targetRef = useRef(null);
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [ALLLISTDATA, setListData] = useState([]);
  const [TOTALPAGES, setTotalPages] = useState(1);
  const [LIMIT, setLimit] = useState(10);
  const [SKIP, setSkip] = useState(0);
  const [filter, setFilter] = useState({
    from: "",
    to: new Date(),
    filter_by: "",
    search: "",
  }); //End

  const [showRequest, setShowRequest] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);


  /*********************************************************
   *  This function is use to fetch vendor list
   *********************************************************/
  const getList = async () => {
    try {
      setIsLoading(true);
      setListData([]);
      const options = {
        type: "",
        condition: {
          ...(filter?.filter_by === 'first_name' ? {first_name : filter?.search }:null),
          ...(filter?.filter_by === 'last_name' ? {last_name : filter?.search }:null),
          ...(filter?.filter_by === 'email' ? {email : filter?.search }:null),
          ...(filter?.filter_by === 'store_name' ? {store_name : { $regex: filter?.search, $options: "i" } }:null),
          ...(filter?.filter_by === 'mobile' ? {mobile : parseInt(filter?.search) }:null),
          ...(filter?.bind_person_id ? {bind_person_id: {$in : filter?.bind_person_id}} : null),
          ...(showRequest ? { status: showRequest } : null),
        },
        select: {  },
        sort: { _id: -1 },
        skip: SKIP ? SKIP : 0,
        limit: LIMIT ? LIMIT : 10,
      };
      const listData = await list(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setListData(listData?.result);
          setTotalPages(getPage(listData?.count, LIMIT))
        } else {
          setListData([]);
          setTotalPages(getPage(1))
        }
      } else {
        setListData([]);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }; //End

  /*********************************************************
   *  This function is for handle page change
   *********************************************************/
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
    setSkip((newPage - 1) * LIMIT);
    targetRef.current.scrollIntoView({
      behavior: "smooth",
    });
  };

  /*********************************************************
   *  This function is ued for handle filter input change
   *********************************************************/
  const handleFilterReset = () => {
    try {
      setFilter('');
      inputRef1.current.value = '';
      inputRef2.current.value = '';
      inputRef3.current.value = '';
      inputRef4.current.value = '';
    } catch (error) {
      
    }
  }

  const handleFilterApply = (e) => {
    try {
      e.preventDefault();
      const form = new FormData(e.target);
      setFilter((pre)=>({
        ...pre,
        'filter_by' : form.get('filter_by') || '',
        'search'    : form.get('search') || '',
        'to'        : form.get('to_date') || '',
        'from'      : form.get('from_date') || '',

      }))
      // console.log('filter',filter);
      // alert('submit');
      handleFilterDrawer();
      setSkip(0);
    } catch (error) {
      
    }
  }

  /*********************************************************
   *  This function will load when page load and with dependency update
   *********************************************************/
  useEffect(() => {
    getList();
    targetRef.current.scrollIntoView({
      behavior:'smooth',
    });
    document.title = "U-Winn CRM || User's request list";
  }, [currentPage, showRequest, isFilterShow, LIMIT]);

  const handleView = async (item) => {
    try {
      navigate("/users/request-view",{state : item});
    } catch (error) {
      
    }
  }
  const handleBindWith = (value) => {
    setFilter((pre) => ({ ...pre, bind_person_id: value }));
  }

  /*********************************************************
   *  Checkbox Selection Functions
   *********************************************************/
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
      setSelectAll(false);
    } else {
      setSelectedRows(ALLLISTDATA.map(item => item._id));
      setSelectAll(true);
    }
  };

  const handleSelectRow = (id) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter(rowId => rowId !== id));
      setSelectAll(false);
    } else {
      const newSelected = [...selectedRows, id];
      setSelectedRows(newSelected);
      if (newSelected.length === ALLLISTDATA.length) {
        setSelectAll(true);
      }
    }
  };

    // Helper function to detect image format and format base64 data URI
const formatImageDataUri = (base64Image, imageUrl = '') => {
  if (!base64Image || typeof base64Image !== 'string') {
    console.warn('formatImageDataUri: Invalid input', typeof base64Image);
    return null;
  }
  
  // If already formatted as data URI, return as is
  if (base64Image.startsWith('data:')) {
    console.log('formatImageDataUri: Already formatted as data URI');
    return base64Image;
  }
  
  // If it's a URL, return as is (though this shouldn't happen for PDF images)
  if (base64Image.startsWith('http')) {
    console.warn('formatImageDataUri: Received HTTP URL instead of base64');
    return base64Image;
  }
  
  // Remove any whitespace or newlines
  const cleanBase64 = base64Image.replace(/\s/g, '');
  
  // Detect format from URL extension
  let imageType = 'jpeg'; // default
  if (imageUrl) {
    const urlLower = imageUrl.toLowerCase();
    if (urlLower.includes('.png')) {
      imageType = 'png';
    } else if (urlLower.includes('.jpg') || urlLower.includes('.jpeg')) {
      imageType = 'jpeg';
    } else if (urlLower.includes('.webp')) {
      imageType = 'webp';
    } else if (urlLower.includes('.gif')) {
      imageType = 'gif';
    }
  }
  
  // Try to detect from base64 data (magic bytes)
  // PNG: starts with iVBORw0KGgo
  // JPEG: starts with /9j/
  // GIF: starts with R0lGOD
  if (cleanBase64.startsWith('iVBORw0KGgo')) {
    imageType = 'png';
  } else if (cleanBase64.startsWith('/9j/')) {
    imageType = 'jpeg';
  } else if (cleanBase64.startsWith('R0lGOD')) {
    imageType = 'gif';
  }
  
  console.log(`formatImageDataUri: Detected type=${imageType}, base64 length=${cleanBase64.length}`);
  return `data:image/${imageType};base64,${cleanBase64}`;
};

  // Helper function to process a single image field
const processImageField = async (imageData, fieldName) => {
  if (!imageData) return null;
  
  try {
    // Extract image URL - handle both string and object formats
    const imageUrl = typeof imageData === 'string' 
      ? imageData 
      : imageData[fieldName] || imageData;
    if (!imageUrl) return null;
    const apiResponse = await getBas264Image({image_url: imageUrl});
    let base64Image = null;
    if (apiResponse && typeof apiResponse === 'object') {
      if (apiResponse.status === false) {
        console.error(`Failed to fetch ${fieldName} image:`, apiResponse.message);
        return null;
      }
      base64Image = apiResponse.data || apiResponse.image || apiResponse.base64 || apiResponse.result || apiResponse;
    } else if (typeof apiResponse === 'string') {
      base64Image = apiResponse;
    }
    
    if (base64Image && typeof base64Image === 'string') {
      const formattedImage = formatImageDataUri(base64Image, imageUrl);
      
      if (formattedImage) {
        return formattedImage;
      } else {
        return null;
      }
    }
    
    return null;
  } catch (error) {
    console.error(`Error processing ${fieldName} image:`, error);
    return null;
  }
};

  /*********************************************************
   *  Download Selected Rows as PDF in ZIP
   *********************************************************/
  const handleDownloadSelectedPDF = async () => {
    try {
      if (selectedRows.length === 0) {
        notification.warning({
          message: "No Selection",
          description: "Please select at least one row to download.",
          placement: "topRight",
          duration: 3,
        });
        return;
      }

      setIsDownloading(true);
      notification.info({
        message: "Processing",
        description: `Generating ${selectedRows.length} PDF(s)... Please wait.`,
        placement: "topRight",
        duration: 2,
      });

      const zip = new JSZip();
      const selectedData = ALLLISTDATA.filter(item => selectedRows.includes(item._id));

      // Generate PDFs for all selected rows
      for (let i = 0; i < selectedData.length; i++) {
        const item = selectedData[i];
        const fileName = `Request_${item.first_name}_${item.last_name}_${item._id}.pdf`;
        
        // Convert images to base64
        const images = {};
        if (item.tradeLicense) {
          images.tradeLicense = await processImageField(item.tradeLicense, 'tradeLicense');
        }
        if (item.id_proof_front) {
          images.id_proof_front = await processImageField(item.id_proof_front, 'id_proof_front');
        }
        if (item.id_proof_back) {
          images.id_proof_back = await processImageField(item.id_proof_back, 'id_proof_back');
        }
        if (item.signature) {
          images.signature = await processImageField(item.signature, 'signature');
        }
        if (item.agent_signature) {
          images.agent_signature = await processImageField(item.agent_signature, 'agent_signature');
        }
        
        // Generate PDF blob with images
        const pdfDoc = <RequestDetailsPDF data={item} images={images} />;
        const blob = await pdf(pdfDoc).toBlob();
        
        // Add to zip
        zip.file(fileName, blob);
      }

      // Generate and download zip file
      const zipBlob = await zip.generateAsync({ type: "blob" });
      saveAs(zipBlob, `User_Requests_${new Date().getTime()}.zip`);

      notification.success({
        message: "Success",
        description: `${selectedRows.length} PDF(s) downloaded successfully.`,
        placement: "topRight",
        duration: 3,
      });

      // Clear selection
      setSelectedRows([]);
      setSelectAll(false);
      setIsDownloading(false);
    } catch (error) {
      console.error("Error downloading PDFs:", error);
      notification.error({
        message: "Error",
        description: "Failed to download PDFs. Please try again.",
        placement: "topRight",
        duration: 3,
      });
      setIsDownloading(false);
    }
  };

  // Clear selections when data changes
  useEffect(() => {
    setSelectedRows([]);
    setSelectAll(false);
  }, [ALLLISTDATA]);

  /*********************************************************
   *  This function is for handle limit change
   *********************************************************/
  const handleLimitChange = (e) => {
    const newLimit = parseInt(e.target.value);
    setLimit(newLimit);
    setCurrentPage(1);
    setSkip(0);
  };

  const theadThStyle = {
    backgroundColor: "#1b5e20",
    color: "#fff",
    borderColor: "#14532d",
  };

  return (
    <>
      <div className="container-fluid" ref={targetRef}>
        <TobNavBar title={"User's request list"} />
        <div className="inventory_tabs_main_div">
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <div className="inventory_all_tabs">
                <div className="all_tabs_value">
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    className="item_tabs_main_container"
                  >
                    <Tab
                      label="All"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() =>  setShowRequest("") }
                    />
                    <Tab
                      label="Pending"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => setShowRequest("Pending")}
                    />

                    <Tab
                      label="Completed"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => setShowRequest("Completed")}
                    />

                    <Tab
                      label="Rejected"
                      className="tabs_main_contnet"
                      {...a11yProps(0)}
                      onClick={() => setShowRequest("Rejected")}
                    />
                  </Tabs>
                </div>

                <div className="fa_filter_rating_review filter_img_and_add_btn_main">
                  <div className="inventory_filter_div" onClick={handleFilterDrawer}>
                    <FontAwesomeIcon icon={faFilter} />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Filter
                    </Link>
                  </div>
                  <div className="inventory_filter_div" onClick={handleExportDrawer}>
                    <FontAwesomeIcon icon={faCloudDownload} />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      Export
                    </Link>
                  </div>

                  <div className="inventory_filter_div" style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <label htmlFor="rowsPerPage" style={{ margin: 0, fontSize: "14px", whiteSpace: "nowrap" }}>
                      Rows:
                    </label>
                    <select
                      id="rowsPerPage"
                      value={LIMIT}
                      onChange={handleLimitChange}
                      className="form-control"
                      style={{
                        minWidth: "80px",
                        padding: "4px 8px",
                        fontSize: "14px",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        cursor: "pointer"
                      }}
                    >
                      <option value={2}>2</option>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                      <option value={1000}>1000</option>
                    </select>
                  </div>

                  <div 
                    className="inventory_filter_div" 
                    onClick={handleDownloadSelectedPDF}
                    style={{ 
                      cursor: selectedRows.length === 0 || isDownloading ? 'not-allowed' : 'pointer',
                      opacity: selectedRows.length === 0 || isDownloading ? 0.5 : 1 
                    }}
                  >
                    <FontAwesomeIcon icon={faFileArchive} />
                    <Link
                      to={false}
                      className="filter_btn_invontry_rating_review"
                    >
                      {isDownloading ? 'Downloading...' : `Download PDF${selectedRows.length > 0 ? ` (${selectedRows.length})` : ''}`}
                    </Link>
                  </div>
                </div>
              </div>
            </Box>            
            <VendorList 
              >
              <div>
                <div id="content-wrapper" className="d-flex flex-column">
                  <div
                    className="card shadow mb-4"
                    style={{
                      backgroundColor: "#c8e6c9",
                      borderLeft: "4px solid #1b5e20",
                    }}
                  >
                    <div className="card-body pt-0">
                      <div className="table-responsive">
                        <table
                          className="table table-bordered"
                          id="dataTable"
                          width="100%"
                          cellSpacing="0"
                        >
                          <thead>
                            <tr>
                              <th
                                style={{
                                  width: "50px",
                                  textAlign: "center",
                                  ...theadThStyle,
                                }}
                              >
                                <input 
                                  type="checkbox" 
                                  checked={selectAll}
                                  onChange={handleSelectAll}
                                  style={{cursor: 'pointer', width: '18px', height: '18px'}}
                                />
                              </th>
                              <th style={theadThStyle}>Sl. No.</th>
                              <th style={theadThStyle}>Customer's Details</th>
                              <th style={theadThStyle}>Bind With</th>
                              <th style={theadThStyle}>Area</th>
                              <th style={theadThStyle}>Status</th>
                              <th style={theadThStyle}>Created At</th>
                              <th style={theadThStyle}>Updated At</th>
                              {(PERMISSION?.view === 'Y' || PERMISSION?.fullAccess === 'Y') && (
                                <th style={theadThStyle}>Action</th>
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {ALLLISTDATA?.length > 0 ? (
                              ALLLISTDATA.map((items, index) => (
                                <>
                                  <tr key={index}>
                                    <td style={{textAlign: 'center'}}>
                                      <input 
                                        type="checkbox" 
                                        checked={selectedRows.includes(items._id)}
                                        onChange={() => handleSelectRow(items._id)}
                                        style={{cursor: 'pointer', width: '18px', height: '18px'}}
                                      />
                                    </td>
                                    <td>{SKIP + index + 1}</td>
                                    <td className="admin_user_list_date">
                                      {items?.store_name        && (<span>Store   : {items?.store_name}<br/></span>)} 
                                      {items?.first_name        && (<span>Name    : {items?.first_name} {items?.last_name}<br/></span>)} 
                                      {items?.email             && (<span>Email   : {items?.email}<br/></span>)} 
                                      {items?.mobile            && (<span>Mobile  : {items?.mobile}<br/></span>)}                                       
                                    </td>
                                    <td className="admin_user_list_date">
                                      {items?.bind_person_id?.users_name && (<span>{items?.bind_person_id?.users_name}<br/></span>)}
                                      {items?.bind_person_id?.users_type && (<span>Type : {items?.bind_person_id?.users_type}<br/></span>)}
                                      {items?.bind_person_id?.users_mobile && (<span>Phone : {items?.bind_person_id?.users_mobile}<br/></span>)}
                                    </td>
                                    <td className="admin_user_list_date">{items?.area || 0}</td>

                                    <td className="admin_user_list_date">
                                      <UserRequestStatusDots item={items} />
                                    </td>
                                    <td className="admin_user_list_date">{moment(items?.createdAt).format('DD-MM-YYYY HH:mm')}</td>
                                    <td className="admin_user_list_date">{moment(items?.updatedAt).format('DD-MM-YYYY HH:mm')}</td>
                                    {(PERMISSION?.view === 'Y' || PERMISSION?.fullAccess === 'Y') && (
                                      <td>
                                        <button type="button" class="btn btn-dark" onClick={()=>handleView(items)}>
                                          <FontAwesomeIcon icon={faEye} /> View
                                        </button>
                                      </td>
                                    )}
                                  </tr>
                                </>
                              ))
                            ) : isLoading ? <SkeltonList row={10} col={10} /> : <tr> 
                                <td colspan="10" className="img-center" >No data found !</td> 
                            </tr>}
                          </tbody>
                        </table>
                        <div className="table_pagination_sales_order">
                          <Pagination
                            count={TOTALPAGES}
                            onChange={handlePageChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </VendorList>
          </Box>
        </div>
      </div>
      <ExportPopup popUpOpen={isExportShow} togglePopUp={handleExportDrawer} />
      {/* Filter */}
      <Drawer
        title="Filter"
        placement={`right`}
        width={500}
        onClose={handleFilterDrawer}
        open={isFilterShow}
        extra={
          <Space>
            <Button onClick={handleFilterDrawer}>Cancel</Button>
            <Button type="primary" onClick={handleFilterReset}  style={{ backgroundColor: 'red', color: 'white' }}>
              Reset
            </Button>
          </Space>
        }
      >
        <div className="responsive">
          <div className="row">
            <form id='filter_form' onSubmit={handleFilterApply}>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="select_bind_with" className="all_section_for_label_main_class" >
                  Select Bind With :
                </label>
                <UserSelectWithSearch
                  value={filter?.bind_person_id}
                  onChange={(value) => handleBindWith(value)}
                  placeholder="Select bind with users"
                  className="form-control store_input_field"
                  style={{ width: '100%' }}
                  disableOptions={false}
                />
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Field :
                </label>
                <select name="filter_by" className="form-control store_input_field" id="filter_by" ref={inputRef1}>
                  <option value=''>Select search field</option>
                  <option value='first_name' selected={filter?.filter_by ==='first_name'?true:false}>First Name</option>
                  <option value='last_name' selected={filter?.filter_by ==='last_name'?true:false}>Last Name</option>
                  <option value='email' selected={filter?.filter_by ==='email'?true:false}>Email</option>
                  <option value='store_name' selected={filter?.filter_by ==='store_name'?true:false}>Store name</option>
                  <option value='mobile' selected={filter?.filter_by ==='mobile'?true:false}>Mobile</option>
                </select>
              </div>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label htmlFor="vendor_first_name" className="all_section_for_label_main_class" >
                  Search Text :
                </label>
                <input
                  title="Enter search text."
                  placeholder="Enter search text."
                  type="text"
                  name="search"
                  className="form-control store_input_field"
                  id="search"  
                  ref={inputRef2}
                />
              </div>
              <br/>
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <button
                  title="Enter search text."
                  type="submit"
                  className="form-control btn btn-black"    
                  style={{ backgroundColor: "black", color: "white" }}           
                >Apply</button>
              </div>
            </form>
          </div>
        </div>
      </Drawer>
    </>
  );
}
